import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from '@environments/environment.prod';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';
import {NavigationPort} from '@shared/application/ports/navigation/navigation.port';
import {AgreementPort} from '@features/agreement/application/ports/agreement.port';
import {
  CreateAgreementPayloadDto
} from '@features/agreement/application/use_cases/create-agreement/dto/create-agreement.payload.dto';
import {
  CreateAgreementResponseDto
} from '@features/agreement/application/use_cases/create-agreement/dto/create-agreement.response.dto';
import {
  ListAgreementPayloadDto
} from '@features/agreement/application/use_cases/list-agreement/dto/list-agreement.payload.dto';
import {
  ListAgreementResponseDto
} from '@features/agreement/application/use_cases/list-agreement/dto/list-agreement.response.dto';
import {
  CreateAgreementHttpPayloadDto
} from '@features/agreement/infrastructure/http/create-agreement/create-agreement.http.payload.dto';
import {
  CreateAgreementHttpResponseDto
} from '@features/agreement/infrastructure/http/create-agreement/create-agreement.http.response.dto';
import {
  CreateAgreementHttpMapper
} from '@features/agreement/infrastructure/http/create-agreement/create-agreement.http.mapper';
import {
  ListAgreementHttpPayloadDto
} from '@features/agreement/infrastructure/http/list-agreement/list-agreement.http.payload.dto';
import {
  ListAgreementHttpResponseDto
} from '@features/agreement/infrastructure/http/list-agreement/list-agreement.http.response.dto';
import {
  ListAgreementHttpMapper
} from '@features/agreement/infrastructure/http/list-agreement/list-agreement.http.mapper';
import {FilterInterface} from '@core/interfaces/filter/filter.interface';
import {HttpHeaders} from '@angular/common/http';
import {QueryHttpService} from '@shared/infrastructure/http/services/query-http.service';

@Injectable()
export class AgreementHttpAdapter implements AgreementPort {

  private url = environment.uri;
  private readonly http = inject(ClientHttpPort);
  private readonly queryService: QueryHttpService = inject(QueryHttpService);

  constructor(
    private readonly localStoragePort: LocalStoragePort,
    private readonly navigationPort: NavigationPort,
  ) {
  }

  public createAgreement(payload: CreateAgreementPayloadDto): Observable<CreateAgreementResponseDto> {
    const body = CreateAgreementHttpMapper.toInfra(payload);
    return this.http.post<CreateAgreementHttpPayloadDto, CreateAgreementHttpResponseDto>(`${this.url}agreements`, body)
      .pipe(map((responseHttp) => CreateAgreementHttpMapper.toResponse(responseHttp)));
  }

  public listAgreement(payload: ListAgreementPayloadDto): Observable<ListAgreementResponseDto> {
    const url = window.location.href;
    const {suffix} = this.navigationPort.extractQueryParams(url);
    let suffixDatabase: string | null = null;
    if (!suffix) {
      suffixDatabase = this.localStoragePort.getByKey<string | null>('_suffix');
      if (!suffixDatabase) throw new Error(`Could not find suffix`);
    } else {
      suffixDatabase = suffix;
    }
    const httpPayload = ListAgreementHttpMapper.toInfra(payload);
    const filter: FilterInterface = this.queryService.toQueryFilterModel(payload);
    filter.withRelationships = [];
    if (httpPayload.limit) {
      filter["paginate"] = httpPayload.limit;
    }
    const headers: HttpHeaders = new HttpHeaders({
      "token": environment.secret_key,
      "x-filter-model": JSON.stringify(filter),
    });
    const pageParam = httpPayload.page ? `&page=${httpPayload.page}` : '';
    return this.http.get<ListAgreementHttpResponseDto>(`${this.url}agreement-list?suffix_database=${suffixDatabase}`, {headers})
      .pipe(map((responseHttp) => ListAgreementHttpMapper.toResponse(responseHttp)));
  }

}
